module.exports = __webpack_public_path__ + "static/media/badbeep.5678756b.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/badbeep.wav
// module id = 2830
// module chunks = 0